import { render, staticRenderFns } from "./ButtonEditCdp.vue?vue&type=template&id=7c33b6ee&"
import script from "./ButtonEditCdp.vue?vue&type=script&lang=ts&"
export * from "./ButtonEditCdp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports